import planificationEscl from '../../../locales/es-CL/planification.json';
import planificationEsmx from '../../../locales/es-MX/planification.json';
import planificationEsco from '../../../locales/es-CO/planification.json';
import planificationEnus from '../../../locales/en-US/planification.json';
import userEscl from '../../../locales/es-CL/user.json';
import userEsmx from '../../../locales/es-MX/user.json';
import userEsco from '../../../locales/es-CO/user.json';
import userEnus from '../../../locales/en-US/user.json';
import vehicleEscl from '../../../locales/es-CL/vehicle.json';
import vehicleEsmx from '../../../locales/es-MX/vehicle.json';
import vehicleEsco from '../../../locales/es-CO/vehicle.json';
import vehicleEnus from '../../../locales/en-US/vehicle.json';
import showAlert from '../../../alert/alertHandler';
import axios from 'axios';
import Container from 'typedi';
import LogService from '../../../services/LogService';
import OperationService from '../../../services/OperationService';
import ProgressBar from '../../../components/ProgressBar.vue';
import Multiselect from 'vue-multiselect';
import Optimizer from '../../../utils/optimizer';
import userCrudModal from '../../../user/modalCrudUser/modalCrudUserHandler';
import vehicleCrudModal from '../../../vehicle/vehicleModal/vehicleModalHandler';

export default {
  name: 'ResourceProcess',
  components: {
    Multiselect,
    ProgressBar,
  },
  props: {
    planificationId: {
      type: String,
      default: null,
    },
    planificationState: {
      type: String,
      default: null,
    },
    planificationOngoing: {
      type: Boolean,
      default: false,
    },
  },
  i18n: {
    messages: {
      'es-CL': {
        planification: planificationEscl,
        user: userEscl,
        vehicle: vehicleEscl,
      },
      'es-MX': {
        planification: planificationEsmx,
        user: userEsmx,
        vehicle: vehicleEsmx,
      },
      'es-CO': {
        planification: planificationEsco,
        user: userEsco,
        vehicle: vehicleEsco,
      },
      'en-US': {
        planification: planificationEnus,
        user: userEnus,
        vehicle: vehicleEnus,
      },
    },
  },
  data() {
    return {
      dataVehicleTypeExtra: [],
      mode: null,
      dataGroups: [],
      optimizationOutput: null,
      optimizationInput: null,
      namePlanification: null,
      timeoutID: null,
      autoRefreshTimer: 0,
      autoRefreshTimerLimit: 2,
      actualTimeExcecution: 0,
      limitTimeExecution: 900,
      actualStatusSolver: null,
      currentPageVehicle: 1,
      perPageVehicle: 10,
      pageOptions: [10, 15, 20, 50, 100],
      totalVehicles: 0,
      isMainPageBussy: false,
      isVehicleCrudBussy: false,
      activeMenuOptimization: false,
      showAlertDismissible: false,
      selectedAllVehicles: false,
      executionId: null,
      dataAccess: null,
      filterVehicle: null,
      filterVehicleTemp: null,
      isMainPageBusyy: false,
      isOptimizationBussy: false,
      actualStep: 'resources',
      solverEnd: true,
      planIsOngoing: false,
      isGeoFenceBussy: false,
      useAllFleet: false,
      useGeoFence: false,
      checkedVehicles: [],
      checkedDrivers: [],
      checkedGeoFences: [],
      groups: [],
      geoFence: [],
      vehicles: [],
      vehiclesFilter: [],
      drivers: [],
      preAssignments: [],
      bussyVehicles: [],
      bussyDrivers: [],
      //Información de otros estados
      operations: [],
      spotsTemporalData: [],
      tags: [],
      depotOrigin: null,
      depotDestination: null,
      trafficFactor: { factor: 1, name: this.$t('planification.solver.trafficFactor.dinamic') },
      selectedButtonOption: null,
      buttonOptionsNotOngoing: [
        {
          value: 'reoptimize',
          title: this.$t('planification.planificationBuilder.modal.optimizeTitle'),
          description: this.$t('planification.planificationBuilder.modal.optimize'),
          icon: 'fas fa-sync-alt', // Puedes usar un ícono de FontAwesome u otro
          color: 'blue',
          background: 'blue-back',
          ongoing: false,
          disabled: false,
        },
        {
          value: 'keepRoutes',
          title: this.$t('planification.planificationBuilder.modal.keepOptimizeTitle'),
          description: `${this.$t('planification.planificationBuilder.modal.keepOptimize')}`,
          icon: 'fas fa-route', // Otro ícono
          color: 'orange',
          background: 'orange-back',
          ongoing: false,
          disabled: false,
        },
        {
          value: 'keepRoutesOngoing',
          title: `${this.$t('planification.planificationBuilder.modal.keepOptimizeTitle')}`,
          description: `${this.$t('planification.planificationBuilder.modal.keepOptimize')} ${this.$t(
            'planification.planificationBuilder.modal.keepOptimizeOngoing',
          )}`,
          icon: 'fas fa-sync-alt', // Puedes usar un ícono de FontAwesome u otro
          color: 'orange',
          background: 'orange-back',
          ongoing: true,
          disabled: false,
        },
        {
          value: 'manual',
          title: this.$t('planification.planificationBuilder.modal.manualOptimizeTitle'),
          description: `${this.$t('planification.planificationBuilder.modal.manualOptimize')}`,
          icon: 'fas fa-route', // Otro ícono
          color: 'purple',
          background: 'purple-back',
          ongoing: true,
          disabled: false,
        },
      ],
      form: {
        executionDate: '',
        planificationName: null,
        initHour: '',
        endHour: '',
      },
      distanceMatrixManual: {
        operations: [],
        origins: [],
        destinations: [],
      },
      //Body del optimizador
      optimizationBody: {
        resourceTypes: [],
        name: null,
        startDate: null,
        endDate: null,
        resources: [],
        depots: [],
        spots: [],
        operations: [],
        tags: [],
        parameters: {},
      },
      totalOperationsAssigned: 0,
      totalOperationsNotAssigned: 0,
      optimizationResultParsed: [],
      selectedUser: {
        id: null,
        profile: null,
        firstName: null,
        lastName: null,
        username: null,
        phone: null,
        email: null,
        password: null,
        repeatPassword: null,
        showPassword: false,
        showPasswordRepeat: false,
        isOwner: false,
        vehicle: null,
      },
      operationService: null,
      logService: null,
    };
  },
  beforeDestroy() {
    // Limpia el temporizador cuando el componente se destruya
    this.clearTimeout();
  },
  beforeRouteLeave(to, from, next) {
    const allowedRoutes = [
      'OperationProcess',
      'OperationProcessNotOngoing',
      'DateAndDepotProcess',
      'DateAndDepotProcessNotOngoing',
      'ResourceProcess',
      'ResourceProcessNotOngoing',
      'RouteProcess',
      'RouteProcessNotOngoing',
      'PlanificationBuilder',
      'PlanificationBuilderNotOngoing',
    ];
    if (!allowedRoutes.includes(to.name)) {
      this.$store.commit('setMetaData', null); // Limpia los datos si no es una ruta permitida
      this.$store.commit('setInputOptimization', null);
      this.$store.commit('setOututOptimization', null);
    }
    next(); // Permite la navegación
  },
  created() {
    this.dataAccess = this.$store.getters.dataAccess;
    this.operationService = Container.get(OperationService);
    this.logService = Container.get(LogService);
    this.prepareData();
  },
  methods: {
    async prepareData() {
      this.isMainPageBussy = true;
      this.dataAccess = this.$store.getters.dataAccess;
      await this.prepareDataFromOtherStage();
      if (this.planificationId) {
        this.planIsOngoing = this.planificationState === 'STARTED' || this.planificationState === 'ONGOING';
        //this.planIsOngoing = true;

        const { inputOptimization, outputOptimization } = this.$store.getters;
        const inputOptimizationStr = JSON.stringify(inputOptimization || {});
        const outputOptimizationStr = JSON.stringify(outputOptimization || {});
        this.optimizationInput = JSON.parse(inputOptimizationStr);
        this.optimizationOutput = JSON.parse(outputOptimizationStr);
        console.log('Resultado de la optimizacion ', this.optimizationOutput, this.optimizationInput);

        this.$set(
          this,
          'distanceMatrixManual',
          this.jsonData && this.jsonData.distanceMatrixManual
            ? this.jsonData.distanceMatrixManual
            : {
                operations: [],
                origins: [],
                destinations: [],
              },
        );
      }
      this.namePlanification =
        this.optimizationInput && 'name' in this.optimizationInput ? this.optimizationInput.name : this.form.name;
      //Si vengo desde otro estado, debo actualizar las variables globales desde lo almacenado y no de lo que existe en el body del back
      if (
        this.jsonData.checkedVehicles ||
        this.jsonData.checkedDrivers ||
        this.jsonData.checkedGeoFences ||
        this.jsonData.vehicles ||
        this.jsonData.drivers ||
        this.jsonData.useGeoFence ||
        this.jsonData.useAllFleet
      ) {
        console.log('jsonData ', this.jsonData);
        await this.dataFromOtherStageForResource();
      } else if (this.planificationId) {
        this.preparedEditMode(this.optimizationInput);
      }
      this.getGroups();
      await this.checkBussyVehicles();
      if (this.geoFence.length === 0) {
        this.getGeoFences();
      }
      if (this.planIsOngoing) {
        this.buildResultOptimizationParsed(this.optimizationOutput);
      } else {
        this.applyFilter();
      }
      //this.callTestVehicle();
      //this.callTest(); //metodo que se usa para testear la vista del paso 3, respuesta del optimizador
      this.isMainPageBussy = false;
    },
    buildResultOptimizationParsed(optimizationOutput) {
      optimizationOutput.routes.forEach((route, index) => {
        const resource = route.resources[0];

        let totalDeliveriesOrCollections = 0;
        const tagsMap = new Set();

        resource.operations.forEach((op) => {
          if (op.task === 'DELIVERY' || op.task === 'COLLECTION') {
            totalDeliveriesOrCollections++;
            if (op.tags && Array.isArray(op.tags)) {
              op.tags.forEach((tagId) => {
                if (!tagsMap.has(tagId)) {
                  tagsMap.add(tagId);
                }
              });
            }
          }
        });
        this.totalOperationsAssigned += totalDeliveriesOrCollections;
        const vehicle = this.vehicles.find((veh) => veh.id === resource.extraInfo.vehicle.id);
        const driver = this.drivers.find((driver) => driver.id === resource.extraInfo.driver.id);
        const body = {
          name: `Ruta ${index + 1}`,
          id: route.id,
          totalOperations: totalDeliveriesOrCollections,
          previousVehicleId: vehicle.id,
          vehicle: vehicle,
          driver: driver,
          tags: tagsMap,
          totalDistance: resource.totalDistance,
          totalMoney: resource.totalMoney,
          totalTime: resource.totalTime,
          totalVolume: resource.totalVolume,
          totalWeight: resource.totalWeight,
        };
        this.totalOperationsNotAssigned = this.operations.length - this.totalOperationsAssigned;
        this.optimizationResultParsed.push(body);
      });
      console.log('Este es mi data ', this.optimizationResultParsed);
    },
    preparedEditMode(inputOptimization) {
      console.log('input ', inputOptimization);
      this.showLoadOperationManual = true;
      inputOptimization.resources.forEach((resource) => {
        this.checkedVehicles.push(resource.extraInfo.vehicle.id);
        this.checkedDrivers.push(resource.extraInfo.driver.id);
        if (resource.geofences) {
          //resource.geofences es un listado de ids de geocercas
          this.checkedGeoFences.push({
            id: resource.extraInfo.vehicle.id,
            geofences: resource.geofences,
          });
        }
      });

      if (inputOptimization.parameters && inputOptimization.parameters.useGeofences) {
        this.useGeoFence = inputOptimization.parameters.useGeofences;
      }
      if (inputOptimization.parameters && inputOptimization.parameters.useAllFleet) {
        this.useAllFleet = inputOptimization.parameters.useAllFleet;
      }
    },
    /**
     * Como bien dice el metodo, prepara las variables globales dependiendo de que proceso de la planificación proviene
     */
    async prepareDataFromOtherStage() {
      this.$set(this, 'form', this.jsonData.form ?? this.form);
      this.$set(this, 'operations', this.jsonData.operations ?? []);
      console.log('Las operaciones que llegaron a este estado', this.jsonData.operations);

      this.$set(this, 'spotsTemporalData', this.jsonData.spotsTemporalData ?? []);
      this.tags = this.jsonData.tags ?? [];
      this.depotOrigin = this.jsonData.depotOrigin ?? this.depotOrigin;
      console.log('Depot ', this.depotOrigin);
      this.depotDestination = this.jsonData.depotDestination ?? this.depotDestination;
      this.trafficFactor = this.jsonData.trafficFactor ?? this.trafficFactor;
    },

    async dataFromOtherStageForResource() {
      this.$set(this, 'checkedVehicles', this.jsonData.checkedVehicles || []);
      this.$set(this, 'checkedDrivers', this.jsonData.checkedDrivers || []);
      this.$set(this, 'checkedGeoFences', this.jsonData.checkedGeoFences || []);
      this.$set(this, 'vehicles', this.jsonData.vehicles || []);
      this.$set(this, 'drivers', this.jsonData.drivers || []);

      this.useGeoFence = this.jsonData.useGeoFence !== undefined ? this.jsonData.useGeoFence : this.useGeoFence;
      this.useAllFleet = this.jsonData.useAllFleet !== undefined ? this.jsonData.useAllFleet : this.useAllFleet;
    },

    async getGroups() {
      try {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `getGroups api/client/userGroups grupos de usuario para conductores`,
        });
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/client/userGroups`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.groups = response.data.data;
        this.groups.forEach((group) => {
          if (group.name === 'Conductor') {
            this.selectedUser.profile = group;
          }
        });
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getGroups fallo el servicio ${e.message}`,
        });
        console.log(e);
      }
    },
    onVehicleChange(newVehicle, row) {
      // 1. Borrar el anterior
      if (row.previousVehicleId) {
        const index = this.checkedVehicles.indexOf(row.previousVehicleId);
        if (index !== -1) {
          this.checkedVehicles.splice(index, 1);
        }

        const foundVehicle = this.vehicles.find((v) => v.id === row.previousVehicleId);
        if (foundVehicle) {
          foundVehicle.driver = null;
        }
      }
      if (row.driver && newVehicle) {
        const foundVehicle = this.vehicles.find((v) => v.id === newVehicle.id);
        foundVehicle.driver = row.driver;
      }

      // 2. Agregar el nuevo
      if (newVehicle && newVehicle.id && !this.checkedVehicles.includes(newVehicle.id)) {
        this.checkedVehicles.push(newVehicle.id);
      }
      if (newVehicle && row.previousVehicleId != newVehicle.id) {
        // 3. Actualizar el previousVehicleId en la fila
        row.previousVehicleId = newVehicle ? newVehicle.id : null;
      }
    },
    /**
     * Este metodo es muy extraño, pero provoca de forma forzada una actualización en los datos de la tabla de recursos
     * @param {*} vehicle
     */
    changeDriver(vehicle) {
      if (vehicle) {
        if (vehicle.driver) {
          console.log('Driver del vehiculo ,', vehicle.driver);
          if (vehicle.driver.id === -1) {
            this.newDriverActivated(vehicle);
          } else {
            this.drivers.find((driver) => {
              if (driver.id == vehicle.driver.id) {
                const name = driver.firstName;
                driver.firstName = 'gatillo cambio';
                driver.firstName = name;
                return driver;
              }
            });
          }
        } else {
          const plate = vehicle.plate;
          vehicle.plate = 'gatillo cambio';
          vehicle.plate = plate;

          vehicle.driver = null;
        }
      }
    },

    async getDataVehicleTypeExtra() {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/vehicleTypeExtra`;
      try {
        const { data } = await axios.get(url, config);
        const { data: typeVehicle } = data;
        return typeVehicle.reverse();
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getDataVehicleTypeExtra fallo traer los tipos de vehículos ${e.message}`,
        });
        console.log(e);
      }
    },
    async getDataGroups() {
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
          //'x-api-key': Container.get('apiKey'),
        },
      };
      const url = `${this.$store.getters.urlAPI}/api/vehicleGroup`;
      try {
        let { data } = await axios.get(url, config);
        let { data: groups } = data;
        return groups.reverse();
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getDataGroups fallo el traer los grupos ${e.message}`,
        });
        console.log(e);
      }
    },
    changeDriverOngoing(route) {
      console.log('nuevo ruta ', route);
      if (route.driver && route.vehicle) {
        const driver = this.drivers.find((driver) => driver.id == route.driver.id);
        const veh = this.vehicles.find((v) => v.id === route.vehicle.id);
        veh.driver = driver;
        console.log('nuevo conductor ', route.vehicle.plate, driver);
      } else if (route.vehicle) {
        route.driver = null;
        const veh = this.vehicles.find((v) => v.id === route.vehicle.id);
        veh.driver = null;
      }
    },
    newDriverActivated(vehicle) {
      (this.selectedUser = {
        ...this.selectedUser,
        id: null,
        firstName: null,
        lastName: null,
        username: null,
        phone: null,
        email: null,
        password: null,
        repeatPassword: null,
        showPassword: false,
        showPasswordRepeat: false,
        isOwner: false,
        vehicle: null,
      }),
        (this.selectedUser.vehicle = vehicle);

      userCrudModal(false, false, true, this.selectedUser, this.groups, async (driver) => {
        driver.driverName = `${this.transformWords(driver.firstName)} ${this.transformWords(driver.lastName)}`;
        this.drivers.push(driver);
        this.drivers.sort((a, b) => a.driverName.localeCompare(b.driverName));
        const veh = this.vehicles.find((veh) => this.selectedUser.vehicle.id == veh.id);
        veh.driver = driver;
      });
    },
    async openCrudVehicle() {
      this.isVehicleCrudBussy = true;
      await this.$nextTick();
      try {
        if (this.dataVehicleTypeExtra.length < 1) {
          this.dataVehicleTypeExtra = await this.getDataVehicleTypeExtra();
        }
        if (this.dataGroups.length < 1) {
          this.dataGroups = await this.getDataGroups();
        }
        this.$store.commit('setVehicles', this.vehicles);
        vehicleCrudModal(
          false,
          false,
          null,
          {
            drivers: this.drivers,
            driverVehicle: this.preAssignments,
          },
          this.dataVehicleTypeExtra,
          this.tags,
          this.dataGroups,
          async (vehicle, idDriver, finalProcess) => {
            //El modal de vehiculos hace varios callback para actualizar el listado de preasignaciones
            if (finalProcess) {
              this.isMainPageBussy = true;
              if (vehicle.vehicleTypeExtra) {
                //Esto se realiza porque el return del insert no trae el nombre del tipo de vehículo
                const dataTypeExtra = this.dataVehicleTypeExtra.find(
                  (vtype) => vtype.id === vehicle.vehicleTypeExtra.id,
                );
                if (dataTypeExtra) {
                  vehicle.vehicleTypeExtra = dataTypeExtra;
                }
              }
              if (vehicle.driver) {
                await this.getVehicleAssignments();
              }
              vehicle.available = true;
              this.vehicles.push(vehicle);
              //Ordeno la lista de vehículos por patente
              this.vehicles.sort((a, b) => a.plate.localeCompare(b.plate));
              this.transformVehicleData();
              this.isMainPageBussy = false;
            } else {
              this.setDriverVehicle(vehicle && vehicle.id ? vehicle.id : null, idDriver);
            }
          },
        );
      } finally {
        // 🔹 Siempre liberar el botón después de abrir el modal
        this.isVehicleCrudBussy = false;
      }
    },

    async setDriverVehicle(idVehicle, idDriver) {
      let requireChange = true;
      if (idVehicle != null && idDriver != null) {
        this.preAssignments.forEach((dV) => {
          if (idVehicle === dV.idVehicle[0] && idDriver === dV.idDriver) {
            requireChange = false;
          }
        });
      }
      console.log('idVehicle: ' + idVehicle + ', idDriver: ' + idDriver + ', requireChange: ' + requireChange);

      if (requireChange) {
        //Si recibo el dato nulo, quiero liberar del conductor los vehículos
        let idDriverTemp = null;
        if (idDriver === null) {
          this.preAssignments.forEach((dV) => {
            if (idVehicle === dV.idVehicle[0]) {
              idDriverTemp = dV.idDriver;
            }
          });
        }
        this.logService.sendInfo({
          component: 'vehicle',
          message: `setDriverVehicle preparando la data idVehicle: ${idVehicle}, idDriver: ${idDriver}, idDriverTemp: ${idDriverTemp}`,
        });
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const url = `${this.$store.getters.urlAPI}/driverVehicle/${idDriver != null ? idDriver : idDriverTemp}/vehicle`;

        this.logService.sendInfo({
          component: 'vehicle',
          message: `setDriverVehicle consultando al servicio ${url}`,
        });
        let idVehicles = idVehicle != null ? [idVehicle] : [];
        if (idDriver === null) {
          idVehicles = [];
        }
        try {
          await axios.put(url, idVehicles, config);
        } catch (e) {
          this.logService.sendError({
            component: 'vehicle',
            message: `setDriverVehicle fallo ${e.message}`,
          });
          console.log(e);
        }
      }
    },
    chooseVehicle(vehicle) {
      this.selectedVehicle = vehicle;
    },
    async checkBussyVehicles() {
      this.isMainPageBussy = true;
      await this.getVehicleAssignments();
      //Si tengo el listado vacio voy a buscar los vehículos del cliente
      if (this.vehicles.length === 0) await this.getVehicles();
      if (this.drivers.length === 0) await this.getDrivers();
      [this.bussyVehicles, this.bussyDrivers] = await this.getBussyVehicles();
      //Esto solo funciona si estoy en modo editar
      if (this.planificationId && this.checkedVehicles.length > 0) {
        const bussyVehicles = this.unlinkResourceBussyVehicle();
        const bussyDrivers = this.unlinkResourceBussyDriver();
        if (bussyVehicles.length > 0 || bussyDrivers.length > 0) this.showAlertDismissible = true;
        //Envia las alertas dependiendo si los listados entregados poseen datos
        if (bussyVehicles.length > 0 && bussyDrivers.length > 0)
          showAlert(
            'Error',
            /* this.$t('planification.planificationBuilder.bussyDriverVehicle', {
                vehicles: bussyVehicles,
                drivers: bussyDrivers,
              }), */
            this.$t('planification.planificationBuilder.bussyDriverVehicleSimple'),
          );
        else if (bussyVehicles.length > 0)
          /* showAlert('Error', this.$t('planification.planificationBuilder.bussyVehicle', { vehicles: bussyVehicles })); */
          showAlert('Error', this.$t('planification.planificationBuilder.bussyVehicleSimple'));
        else if (bussyDrivers.length > 0)
          /* showAlert('Error', this.$t('planification.planificationBuilder.bussyDriver', { drivers: bussyDrivers })); */
          showAlert('Error', this.$t('planification.planificationBuilder.bussyDriverSimple'));
      }
      this.transformVehicleData();
      this.drivers = this.drivers.filter((driver) => !this.bussyDrivers.includes(driver.id));

      this.totalVehicles = this.vehicles.length;
      this.availableVehicles = this.totalVehicles - this.bussyVehicles.length;

      this.isMainPageBussy = false;
    },
    //Esta función construye el body de los vehículos para usarlos en la tabla visual
    transformVehicleData() {
      this.vehicles.forEach((vehicle) => {
        this.assignDriver(vehicle);
        this.assignCapacity(vehicle);
        this.updateAvailability(vehicle);
      });
    },
    /**
     * Asigna el conductor a un vehículo
     */
    assignDriver(vehicle) {
      if (this.planificationId && this.checkedVehicles.length > 0) {
        const position = this.checkedVehicles.indexOf(vehicle.id);
        if (position > -1) {
          const driver = this.drivers.find((d) => this.checkedDrivers[position] == d.id);
          if (driver) {
            vehicle.driver = driver;
            return;
          }
        }
      }

      // Si no encontró conductor por edición, busca en preAssignments
      const assignment = this.preAssignments.find((a) => a.idVehicle[0] === vehicle.id);
      if (assignment) {
        const driver = this.drivers.find((d) => d.id === assignment.idDriver);
        if (driver && !this.bussyDrivers.includes(driver.id)) {
          if (this.planificationId) {
            if (!vehicle.driver) {
              vehicle.driver = driver;
            }
          } else {
            vehicle.driver = driver;
          }
        }
      }
    },
    /**
     * Asigna la capacidad de peso/volumen o "Sin restricciones"
     */
    assignCapacity(vehicle) {
      vehicle.description = vehicle.name;

      const weight = vehicle.vehicleTypeExtra?.maxWeigth || 0;
      const volume = vehicle.vehicleTypeExtra?.maxVolume || 0;
      vehicle.capacity = weight === 0 && volume === 0 ? 'Sin restricciones' : `${weight} / ${volume}`;
    },

    /**
     * Actualiza la disponibilidad del vehículo
     */
    updateAvailability(vehicle) {
      const isAvailable = !this.bussyVehicles.includes(vehicle.id);
      vehicle.available = isAvailable;
      vehicle.$isDisabled = !isAvailable;
    },
    unlinkResourceBussyVehicle() {
      let beforeFilter = this.checkedVehicles.length;
      //Dejo los vehículos inhabilitados
      let vehiclesBussy = this.checkedVehicles.filter((vehicleId) => this.bussyVehicles.includes(vehicleId));
      //Dejo los vehículos habilitados
      this.checkedVehicles = this.checkedVehicles.filter((vehicleId) => !this.bussyVehicles.includes(vehicleId));
      let afterFilter = this.checkedVehicles.length;

      //Si luego del filtro los vehículos seleccionados ahora son menos, entonces se gatilla la alerta
      //showAlert('Error', this.$t('planification.planificationBuilder.bussyVehicle', { vehicles: vehicleBussyPlate }));

      return beforeFilter != afterFilter
        ? this.vehicles
            .filter((vehicle) => vehiclesBussy.includes(vehicle.id))
            .map((vehicle) => {
              return vehicle['plate'];
            })
        : [];
    },
    unlinkResourceBussyDriver() {
      let beforeFilter = this.checkedDrivers.length;
      //Dejo los conductores inhabilitados
      let driversBussy = this.checkedDrivers.filter((driverId) => this.bussyDrivers.includes(driverId));
      //Dejo solamente conductores habilitados
      this.checkedDrivers = this.checkedDrivers.filter((driverId) => !this.bussyDrivers.includes(driverId));
      let afterFilter = this.checkedDrivers.length;
      //Si luego del filtro los conductores seleccionados ahora son menos, entonces se gatilla la alerta
      //showAlert('Error', this.$t('planification.planificationBuilder.bussyDriver', { drivers: driversNameBussy }));

      return beforeFilter != afterFilter
        ? this.drivers
            .filter((driver) => driversBussy.includes(driver.id))
            .map((driver) => {
              return driver['driverName'];
            })
        : [];
    },
    async getDrivers() {
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `getDrivers /api/driver?provider=true conductores de lastmile`,
      });
      const urlDrivers = `${this.$store.getters.urlAPI}/api/driver?provider=true`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const driverPromise = await axios.get(urlDrivers, config);
        this.drivers = driverPromise.data.data;
        this.drivers.forEach((driver) => {
          driver.driverName = `${this.transformWords(driver.firstName)} ${this.transformWords(driver.lastName)}`;
          driver.identifier = driver.username + ' | ' + driver.firstName + ' ' + driver.lastName;
        });
        this.drivers.sort((a, b) => a.driverName.localeCompare(b.driverName));
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getDrivers fallo por lo siguiente: ${e.message}`,
        });
        console.log(e);
      }
    },
    checkVehicles: function () {
      if (this.selectedAllVehicles) {
        this.checkAllVehicles();
      } else {
        this.unCheckAllVehicles();
      }
    },
    checkAllVehicles() {
      const checkedSet = new Set(this.checkedVehicles); // Inicializo con los ya seleccionados (aunque el array comienza vacío)

      for (let vehicle of this.vehiclesFilter) {
        if (!this.bussyVehicles.includes(vehicle.id)) {
          checkedSet.add(vehicle.id); // Set evita duplicados automáticamente
        }
      }

      this.checkedVehicles = Array.from(checkedSet);
    },
    unCheckAllVehicles() {
      this.checkedVehicles = [];
    },
    getTagsAsText(tags) {
      let text = '';
      tags.forEach((tag, index) => {
        if (index > 0) {
          text += tag.name + ', ';
        }
      });
      if (text.length >= 2) {
        text = text.slice(0, -2);
      }
      return text;
    },
    async getVehicles() {
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `getVehicles /api/vehicle?provider=true&requireEnabledSystem=LML&includeTags=true&status=Operativo condcutores habilitados en lastmile UM`,
      });
      //requireEnabledSystem trae vehículos habilitados para el sistema indicado, en este caso es Lastmile
      //(este dato pertenece a la tabla core.system)
      const urlVehicles = `${this.$store.getters.urlAPI}/api/vehicle?provider=true&requireEnabledSystem=LML&includeTags=true&status=Operativo`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehiclePromise = await axios.get(urlVehicles, config);
        const data = vehiclePromise.data.data;
        this.vehicles = [];
        data.forEach((v) => {
          if (v.vehicleTypeExtra) {
            this.vehicles.push({
              ...v,
              selectedGeoFence: null,
              geoFence: [],
            });
          }
        });
        console.log(this.vehicles);
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getVehicles fallo al consultar a la api ${e.message}`,
        });
        console.log(e);
      }
    },
    async getVehicleAssignments() {
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `getVehicleAssignments obteniendo preasignacion /driverVehicle`,
      });
      const urlAssignments = `${this.$store.getters.urlAPI}/driverVehicle`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const vehicleAssignmentsPromise = await axios.get(urlAssignments, config);
        this.preAssignments = vehicleAssignmentsPromise.data.data;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getVehicleAssignments la consulta fallo ${e.message}`,
        });
        console.log(e.response);
      }
    },
    async getBussyVehicles() {
      let startDate = this.form.executionDate + ' ' + this.form.initHour;
      let endDate = this.form.executionDate + ' ' + this.form.endHour;

      const dateFrom = new Date(startDate);
      const secondsFrom = dateFrom.getTime();

      const dateUntil = new Date(endDate);
      const secondsUntil = dateUntil.getTime();

      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `getBussyVehicles esta consultando a lo siguiente /planification/checkBussyVehicles?startDateFilter=${secondsFrom}&endDateFilter=${secondsUntil}`,
      });

      const urlToken = `${this.$store.getters.urlAPI}/planification/checkBussyVehicles?startDateFilter=${secondsFrom}&endDateFilter=${secondsUntil}`;

      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        const response = await axios.get(urlToken, config);
        let vehiclesBussy = [];
        let driverBussy = [];
        response.data.data.forEach((plan) => {
          if (this.planificationId == null || this.planificationId != plan.id) {
            plan.resources.forEach((resource) => {
              vehiclesBussy.push(resource.id);
              driverBussy.push(resource.idDriver);
            });
          }
        });
        vehiclesBussy = [...new Set(vehiclesBussy)];
        driverBussy = [...new Set(driverBussy)];

        return [vehiclesBussy, driverBussy];
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getBussyVehicles fallo por lo siguiente: ${e.message}`,
        });
        this.isMainPageBussy = false;
        console.log(e);
        return [[], []];
      }
    },
    async getGeoFences() {
      try {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `getGeoFences obteniendo geocercas del cliente`,
        });
        this.isGeoFenceBussy = true;
        const response = await axios.get(`${this.$store.getters.urlAPI}/geofence?onlyActives=true`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.geoFence = response.data.data;
        this.geoFence.sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        console.log(this.geoFence);
        if (this.geoFence.length > 0) {
          this.getVehicleGeofence();
          if (this.planificationId && this.useGeoFence) {
            this.syncVehicleGeofence();
          }
        }
        this.isGeoFenceBussy = false;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getGeoFences fallo el servicio ${e.message}`,
        });
        this.isGeoFenceBussy = false;
        this.geoFence = [];
        console.log(e);
      }
    },
    getVehicleGeofence() {
      const mappedGeoFences = this.geoFence.map((g) => ({
        id: g.id,
        name: g.name,
        points: g.zone.map((z) => [z.lon, z.lat]),
      }));

      this.vehicles.forEach((veh) => {
        veh.geoFence = [...mappedGeoFences];
      });
    },
    /**
     * Sincroniza los vehículos seleccionados con sus geocercas seleccionadas si es que se seleccionan
     */
    syncVehicleGeofence() {
      this.checkedVehicles.forEach((vId) => {
        const vehicle = this.vehicles.find((v) => v.id === vId);
        if (!vehicle || vehicle.geoFence.length === 0 || this.checkedGeoFences.length === 0) {
          return;
        }
        //Obtengo el objeto de la geofence seleccionada para el vehículo
        const objGeofence = this.checkedGeoFences.find((checkGeo) => checkGeo.id === vehicle.id);
        if (!objGeofence) {
          return;
        }
        //Del resultado anterior, ahora busco la geofence dentro del listado de las disponibles en el vehículo
        const selectedGeofence = vehicle.geoFence.find((geo) => objGeofence.geofences.includes(geo.id.toString()));
        //El resultado de la busqueda lo guardo en la variable
        vehicle.selectedGeoFence = selectedGeofence || null; // Si no encuentra, asigna null explícitamente
      });
    },
    //Recorro el listado de mis vehículos seleccionados, y a partir de ellos busco que conductores tengo en cada uno de ellos
    updateCheckedDrivers() {
      const selectedDrivers = this.checkedVehicles
        .map((vehicleId) => {
          const vehicle = this.vehicles.find((v) => v.id === vehicleId);
          return vehicle?.driver?.id || null;
        })
        .filter((id) => id != null); // Eliminamos nulos si es necesario

      this.checkedDrivers = selectedDrivers;
    },
    updateOptimizationOutput() {
      if (!this.optimizationResultParsed.length) return;

      const routeMap = new Map(this.optimizationResultParsed.map((route) => [route.id, route]));
      for (const route of this.optimizationOutput.routes) {
        const updatedRoute = routeMap.get(route.id);
        if (!updatedRoute) continue;
        console.log(route);
        if (updatedRoute.vehicle) {
          route.resources[0].name = updatedRoute.vehicle.plate;
          route.resources[0].extraInfo.vehicle = {
            id: updatedRoute.vehicle.id,
            plate: updatedRoute.vehicle.plate,
            idVehicleOperaciones: updatedRoute.vehicle.idVehicleOperaciones,
          };
        }

        if (updatedRoute.driver) {
          route.resources[0].extraInfo.driver = {
            id: updatedRoute.driver.id,
            driverName: updatedRoute.driver.driverName,
          };
        }
      }
    },
    backDate() {
      this.updateCheckedDrivers();
      if (this.planIsOngoing) {
        this.updateOptimizationOutput();
      }
      this.$store.commit('setMetaData', {
        distanceMatrixManual: this.distanceMatrixManual,
        form: this.form,
        checkedVehicles: this.checkedVehicles,
        checkedDrivers: this.checkedDrivers,
        checkedGeoFences: this.checkedGeoFences,
        vehicles: this.vehicles,
        drivers: this.drivers,
        useGeoFence: this.useGeoFence,
        useAllFleet: this.useAllFleet,
      });
      this.$store.commit('setInputOptimization', this.optimizationInput);
      this.$store.commit('setOututOptimization', this.optimizationOutput);
      if (this.planificationId) {
        this.$router.push({
          name: 'DateAndDepotProcess',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      } else {
        this.$router.push({
          name: 'DateAndDepotProcessNotOngoing',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      }
    },
    async chooseRoutes(mode) {
      if (this.validateCheckVehicles() && this.validateDriversSelected() && this.validateVehiclesInRoute()) {
        try {
          this.logService.sendInfo({
            component: 'planificationBUilder',
            message: `chooseRoutes preparandose para construir el body del optimizador`,
          });
          this.showModal('optimization');
          //Como estoy tratando de crear una planificación, no debo mostrar el menu de optimización
          if (!this.planificationId) {
            this.activeMenuOptimization = false;
            this.chooseOptimizationMode(mode);
          } else {
            this.activeMenuOptimization = true;
          }
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBUilder',
            message: `Algo fallo en el proceso de construir la optimización ${e.message}`,
          });
          this.closeModal('optimization');
          this.isOptimizationBussy = false;
          console.log(e);
          showAlert('Error', e);
        }
      }
    },
    async chooseOptimizationMode(mode) {
      if (mode == null) {
        return;
      }
      this.mode = mode;
      this.isOptimizationBussy = true;
      //Limpio los arrays de spots y operaciones
      this.optimizationBody.tags = []; // Resetear tags también por seguridad
      this.optimizationBody.spots = [];
      this.optimizationBody.operations = [];
      this.optimizationBody.geofences = [];
      this.optimizationBody.parameters = {};
      if (this.planIsOngoing) {
        this.updateOptimizationOutput();
        const emptyList = [];
        const opsWithStatus = await this.operationService.getStatusByPlanification(emptyList, this.planificationId);
        this.updateStatusOperations(this.operations, opsWithStatus);
      }
      this.makeBodyDepots();
      this.makeBodyGeofences();
      await this.addOperations(mode);
      this.assignOrderByResource(mode);
      console.log("Resultado de mis operaciones ",this.optimizationBody.operations);
      await this.makeBodyVehicles();
      await this.addSpots();
      await this.addParameters();
      this.optimizationBody.tags = [...new Set(this.optimizationBody.tags)];
      if (mode === 'optimize' || mode === 'reoptimize' || mode === 'keepRoutes' || mode === 'keepRoutesOngoing') {
        await this.callOptimization();
      } else {
        await this.optimizationManual();
      }
    },
    assignOrderByResource(mode){
      if(!this.planIsOngoing && mode != 'keepRoutesOngoing') return;

      const opsByResource = {};
      for (const op of this.optimizationBody.operations) {
        const { resource, spotEndTime } = op;

        if (resource && spotEndTime != null && spotEndTime > 0) {
          if (!opsByResource[resource]) {
            opsByResource[resource] = [];
          }
          opsByResource[resource].push(op);
        }
      }

      // Paso 2: Ordenar por spotEndTime y asignar _order
      for (const resource in opsByResource) {
        const ops = opsByResource[resource];
        ops.sort((a, b) => a.spotEndTime - b.spotEndTime);

        ops.forEach((op, index) => {
          op._order = index + 1;
        });
      }
      // Eliminamos spotEndTime de todas las operaciones (ya se usó)
      for (const op of this.optimizationBody.operations) {
        delete op.spotEndTime;
      }
    },
    //Si vuelvo a la sección de operaciones voy a actualizar si es que alguna otra operación ha sido gestionada en el tiempo transcurrido
    updateStatusOperations(operations, opsWithStatus) {
      for (let operation of operations) {
        const foundStatus = this.findStatusOperation(operation, opsWithStatus);
        if (foundStatus) {
          operation.operationState = foundStatus.state;
          operation.spotEndTime = foundStatus.spotEndTime;
        } else {
          operation.operationState = 'NOTHANDLED';
        }
      }
    },
    findStatusOperation(operation, opsWithStatus) {
      return opsWithStatus.find((opWStatus) => operation.uuid === opWStatus.uuid && opWStatus.state !== 'NEW');
    },
    async optimizationManual() {
      try {
        console.log('IFO ', this.optimizationBody);
        console.log('OFO ', this.optimizationOutput);
        const pako = require('pako');
        const body = pako.gzip(
          JSON.stringify({
            inputModel: this.optimizationBody,
            output: this.optimizationOutput,
          }),
        );
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `callOptimization pude transformar a gzip el input`,
        });

        const file = new Blob([body], { type: 'application/octet-stream' });
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `callOptimization pudo realizar el blob para hacerlo un file`,
        });

        const formData = new FormData();
        formData.append('file', file, 'file.gz');
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `callOptimization construye el archivo gzip`,
        });
        const url = `${this.$store.getters.urlSolver}/solve/manualOptimize`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            rdm: true,
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            'x-api-key': Container.get('apiKey'),
          },
          responseType: 'arraybuffer',
        };

        const response = await axios.post(url, formData, config);
        const inflate = pako.inflate(response.data, { to: 'string' });
        const restored = JSON.parse(inflate);
        console.log('OFO ', restored);
        this.joinDistanceMatrix(restored);
        this.closeModal('optimization');
        this.goRoutes(restored);
      } catch (e) {
        console.log(e);
      }
    },
    joinDistanceMatrix(manualOptimization) {
      if (manualOptimization.distanceMatrix.spots) {
        this.optimizationOutput.distanceMatrix.spots = manualOptimization.distanceMatrix.spots;
      }
    },
    refreshNamePlan() {
      this.optimizationResult.name = this.form.planificationName;
    },
    refreshOperations() {
      //Dato a considerar a este metodo se entra cuando las operaciones ya estan construidas en el body
      this.optimizationResult.unreachableOperations.forEach((unreach) => {
        let updateOp = this.optimizationBody.operations.find((op) => op.uuid == unreach.uuid);
        if (updateOp) {
          unreach.spot = updateOp.spot;
          unreach.extraInfo = updateOp.extraInfo;
          unreach.name = updateOp.name;
          unreach.tags = updateOp.tags ? updateOp.tags : [];
          unreach.spotServiceTime = updateOp.spotServiceTime;
          unreach.volume = updateOp.volume ? updateOp.volume : 0;
          unreach.weight = updateOp.weight ? updateOp.weight : 0;
          unreach.money = updateOp.money ? updateOp.money : 0;
          unreach.type = updateOp.type;
        }
      });
      this.optimizationResult.routes.forEach((route) => {
        for (let index = route.resources[0].operations.length - 1; index >= 0; index--) {
          let op = route.resources[0].operations[index];
          if (op.uuid != undefined && op.uuid != null) {
            let opUpdate = this.optimizationBody.operations.find((operation) => operation.uuid == op.uuid);
            const loadOperation = route.resources[0].operations[1];
            //Si la operación aun existe, entonces se actualiza
            if (opUpdate) {
              let spotUpdate = this.optimizationBody.spots.find(
                (spot) => parseInt(spot.name) == parseInt(opUpdate.spot),
              );
              //Si el nombre de la operación cambio debo cambiar el nombre del listado de deliveries de la operacion LOAD
              if (op.name != opUpdate.name) {
                let indexDelivery = loadOperation.deliveries.indexOf(op.name);
                if (indexDelivery >= 0) {
                  loadOperation.deliveries[indexDelivery] = opUpdate.uuid;
                }
              }
              op.spot = spotUpdate ? spotUpdate : op.spot;
              op.extraInfo = opUpdate.extraInfo;
              op.name = opUpdate.name;
              op.tags = opUpdate.tags ? opUpdate.tags : [];
              op.operationTime = opUpdate.spotServiceTime;
              op.scheduled = 0;
              op.volume = opUpdate.volume ? opUpdate.volume : 0;
              op.weight = opUpdate.weight ? opUpdate.weight : 0;
              op.money = opUpdate.money ? opUpdate.money : 0;
              op.task = opUpdate.type;
              //Actualizar la operación driving de la operación actualizada
              route.resources[0].operations[index - 1].spot = opUpdate.spot;
            }
            //Si no encuentro la operación significa que fue eliminada
            else {
              if (route.resources[0].operations[index + 1].task == 'END') {
                //Si no hay bodega de destino, entonces la operación final se actualiza con la operación previa a la eliminada
                route.resources[0].operations[index + 1].spot = route.resources[0].operations[index - 2].spot;
              }
              let indexDelivery = loadOperation.deliveries.indexOf(op.uuid);
              let indexDeliverySecond = loadOperation.deliveries.indexOf(op.name);
              if (indexDelivery >= 0) {
                //Operacion LOAD se actualiza su listado de deliveries
                loadOperation.deliveries.splice(indexDelivery, 1);
              } else if (indexDeliverySecond >= 0) {
                //Operacion LOAD se actualiza su listado de deliveries
                loadOperation.deliveries.splice(indexDeliverySecond, 1);
              }
              //Operacion DELIVERY
              route.resources[0].operations.splice(index, 1);
              //Operación DRIVING
              route.resources[0].operations.splice(index - 1, 1);
            }
          }
        }
      });
    },
    addUnassignedOperations(optimizationResult) {
      let i = this.operations.length;
      for (let operation of this.distanceMatrixManual.operations) {
        let operationOptimization = {
          uuid: operation.uuid,
          name: operation.name,
          resourceId: 0,
          idSpotTemporal: operation.idSpotTemporal,
          spotServiceTime: operation.spotServiceTime * 60,
          spot: operation.idSpotTemporal,
          depot: this.depotOrigin.id,
          volume: operation.volume ? operation.volume : 0,
          weight: operation.weight ? operation.weight : 0,
          money: operation.money ? operation.money : 0,
          type: operation.typeOperation.type ? operation.typeOperation.type : operation.typeOperation,
          extraInfo: {
            idSolver: i,
            customerName: operation.contact ? operation.contact.toString() : null,
            customerPhone: operation.phone ? operation.phone.toString() : null,
            customerEmail: operation.email ? operation.email.toString() : null,
            idSender: operation.sender ? operation.sender : null,
            documents: operation.documents ? operation.documents : [],
          },
        };
        if (operation.startHour && operation.endHour) {
          let startDateIso = this.form.executionDate + ' ' + operation.startHour + ':00';
          let startDateTime = new Date(startDateIso).getTime();
          let endDateIso = this.form.executionDate + ' ' + operation.endHour + ':00';
          let endDateTime = new Date(endDateIso).getTime();
          operationOptimization = {
            ...operationOptimization,
            spotTimeWindow: {
              startTime: startDateTime,
              endTime: endDateTime,
            },
          };
        }
        optimizationResult.unreachableOperations.push(operationOptimization);
        i += 1;
      }
    },
    async callDistanceMatrix() {
      const body = {
        origins: this.distanceMatrixManual.origins,
        destinations: this.distanceMatrixManual.destinations,
      };
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `callDistanceMatrix llamando al solver con los datos nuevos`,
        data: body,
      });
      let result = `${this.$store.getters.urlSolver}/distance-matrix`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const statusSolver = await this.axios.post(result, body, config);
        return statusSolver.data;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `callDistanceMatrix fallo el llamado al solver en el distance matrix ${e.message}`,
        });
        console.log(e);
      }
    },
    addNewDistanceMatrix(distanceMatrix, optimizationResult) {
      let distanceMatrixSolver = optimizationResult.distanceMatrix.spots;
      let spotManualDistanceMatrix = distanceMatrix.spots;
      let finalDistanceMatrix = { ...distanceMatrixSolver, ...spotManualDistanceMatrix };

      optimizationResult.distanceMatrix.spots = finalDistanceMatrix;
      console.log('Resultadoo ', optimizationResult.distanceMatrix, optimizationResult.distanceMatrix.spots);
    },
    goRoutes(optimizationResult) {
      this.updateCheckedDrivers();
      //Como ya tengo todo listo y viajare a la siguiente ista debo quitar el optimizationBussy
      this.isOptimizationBussy = false;
      this.$store.commit('setMetaData', {
        distanceMatrixManual: this.distanceMatrixManual,
        form: this.form,
        checkedVehicles: this.checkedVehicles,
        checkedDrivers: this.checkedDrivers,
        checkedGeoFences: this.checkedGeoFences,
        vehicles: this.vehicles,
        drivers: this.drivers,
        useGeoFence: this.useGeoFence,
        useAllFleet: this.useAllFleet,
        geofence: this.geofence,
      });
      this.$store.commit('setOptimizationBody', this.optimizationBody);
      this.$store.commit('setOptimizationResult', optimizationResult);
      this.$store.commit('setInputOptimization', this.optimizationInput);
      this.$store.commit('setOututOptimization', this.optimizationOutput);
      if (this.planificationId) {
        this.$router.push({
          name: 'RouteProcess',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      } else {
        this.$router.push({
          name: 'RouteProcessNotOngoing',
          params: {
            planificationId: this.planificationId,
            planificationState: this.planificationState,
            planificationOngoing: this.planIsOngoing,
          },
        });
      }
    },
    async callOptimization() {
      try {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `callOptimization con el siguiente input`,
        });
        console.log('IFO ', this.optimizationBody);
        const pako = require('pako');
        const body = pako.gzip(JSON.stringify(this.optimizationBody));
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `callOptimization pude transformar a gzip el input`,
        });

        const file = new Blob([body], { type: 'application/octet-stream' });
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `callOptimization pudo realizar el blob para hacerlo un file`,
        });

        const formData = new FormData();
        formData.append('file', file, 'file.gz');
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `callOptimization construye el archivo gzip`,
        });
        const url = `${this.$store.getters.urlSolver}/solve/execution`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            rdm: true,
            'Content-Type': 'multipart/form-data',
            // 'Content-Encoding': 'gzip',
            // 'Content-Type': 'application/json; charset=utf-8',
            //'Accept-Encoding': "gzip",
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
            'x-api-key': Container.get('apiKey'),
          },
        };

        const response = await axios.post(url, formData, config);

        this.executionId = response.data.executionId;
        console.log(this.executionId, response.data.executionId);
        this.solverEnd = false;
        this.autoRefresh();
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `callOptimization fallo en su intento de comunicarse con el solver ${e.message}`,
        });
        this.closeModal('optimization');
        const traductor = (key, opts) => {
          return this.$t(key, opts);
        };
        let detailHtml = Optimizer.processSolverErrors(
          e.response.data.errors,
          this.optimizationBody,
          this.spotsTemporal,
          traductor,
        );
        showAlert('Error', this.$t('planification.solver.genericError'), 'error', null, null, detailHtml);
        this.isOptimizationBussy = false;
        console.log(e);
      }
    },
    closeOptimization() {
      this.solverEnd = true;
      this.autoRefreshTimer = 0;
      this.selectedButtonOption = null;
      this.isOptimizationBussy = false;
      this.clearTimeout();
    },
    async autoRefresh() {
      if (this.$route.name !== 'ResourceProcess' && this.$route.name !== 'ResourceProcessNotOngoing') {
        return;
      }
      if (!this.solverEnd && this.actualTimeExcecution != this.limitTimeExecution) {
        if (this.autoRefreshTimer <= this.autoRefreshTimerLimit) {
          this.timeoutID = setTimeout(() => {
            this.autoRefreshTimer += 1;
            this.autoRefresh();
          }, 1000);
        } else {
          this.autoRefreshTimer = 0;
          this.actualTimeExcecution += 1;
          await this.getStatusSolver();
          this.autoRefresh();
        }
      }
    },
    clearTimeout() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
        console.log('Temporizador cancelado');
      }
    },
    async getStatusSolver() {
      if (!this.executionId) {
        this.solverEnd = true;
        return;
      }
      let result = `${this.$store.getters.urlSolver}/solve/execution/${this.executionId}/status`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const statusSolver = await this.axios.get(result, config);
        if (statusSolver.data.status != 'FAILED') {
          this.actualStatusSolver = statusSolver.data.status;
          if (this.actualStatusSolver == 'DONE') {
            this.solverEnd = true;
            await this.getResponseSolver();
          }
        } else if (statusSolver.data.status == 'FAILED') {
          this.isOptimizationBussy = false;
          this.solverEnd = true;
          this.actualStatusSolver = statusSolver.data.status;
          this.closeModal('optimization');

          const traductor = (key, opts) => {
            return this.$t(key, opts);
          };
          this.logService.sendInfo({
            component: 'planificationBUilder',
            message: `getStatusSolver la optimización no pudo realizarase debido a`,
            data: statusSolver.data.errors,
          });
          let detailHtml = Optimizer.processSolverErrors(
            statusSolver.data.errors,
            this.optimizationBody,
            this.spotsTemporal,
            traductor,
          );
          showAlert('Error', this.$t('planification.solver.genericError'), 'error', null, null, detailHtml);

          console.log('report activity:', statusSolver);
        }
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getStatusSolver fallo la optimización por el error: ${e.message}`,
        });
        console.log(e);
        this.solverEnd = true;
        this.isOptimizationBussy = false;
        showAlert('Error', this.$t('planification.solver.genericError'));
        return [];
      }
    },
    async getResponseSolver() {
      const urlResult = `${this.$store.getters.urlSolver}/solve/execution/${this.executionId}`;
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `getResponseSolver url de consulta ${urlResult}`,
      });
      const pako = require('pako');
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
          responseType: 'arraybuffer',
        };
        const response = await this.axios.get(urlResult, config);
        const inflate = pako.inflate(response.data, { to: 'string' });
        const restored = JSON.parse(inflate);
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `getResponseSolver la respuesta del optimizador fue:`,
        });
        console.log('OFO ', restored);
        this.closeModal('optimization');
        this.goRoutes(restored);
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getResponseSolver obtener y transformar la respuesta fallo ${e.message}`,
        });
        this.isOptimizationBussy = false;
        console.log(e);
      }
    },
    async addSpots() {
      this.optimizationBody.spots = [];
      const executionDate = this.form.executionDate;
      const startDateTime = new Date(`${executionDate} ${this.form.initHour}`).getTime();
      const endDateTime = new Date(`${executionDate} ${this.form.endHour}`).getTime();
      const buildAddressString = (address) => {
        return [
          address.street,
          address.addressComplement,
          address.neighborhood,
          address.city,
          address.state,
          address.country?.name,
        ]
          .filter(Boolean)
          .join(',');
      };
      const buildAddressComplete = (address) => ({
        address: address.street,
        city: address.city,
        state: address.state,
        country: address.country.name,
        addressComplement: address.addressComplement,
        neighborhood: address.neighborhood,
      });
      this.spotsTemporalData.forEach((spot) => {
        try {
          if (this.planificationId) {
            this.distanceMatrixManual.destinations.push({
              name: spot.id,
              lat: spot.address.lat,
              lon: spot.address.lon,
            });
          }
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBuilder',
            message: `addSpots tuvo un error al intentar añadir spots al distance matrix, edición planificación ${this.planificationId} ${e.message}`,
            data: spot,
          });
          throw e;
        }
        try {
          this.optimizationBody.spots.push({
            name: spot.id,
            lat: spot.address.lat,
            lon: spot.address.lon,
            timeWindow: {
              startTime: startDateTime,
              endTime: endDateTime,
            },
            extraInfo: {
              id: spot.id,
              address: buildAddressString(spot.address),
              addressComplete: JSON.stringify(buildAddressComplete(spot.address)),
              hasAddressComp: !!spot.address.addressComplement,
              hasNeighborhood: !!spot.address.neighborhood,
            },
          });
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBuilder',
            message: `addSpots tuvo un error al construir los spots ${e.message}`,
            data: spot,
          });
          throw e;
        }
      });
      if (this.planificationId) {
        //Los nuevos spots añadidos deben considerar su distancia a las bodegas,
        //ya que la bodega no tendra el dato de su distancia hasta estos nuevos puntos
        const destinations = [
          {
            name: this.depotOrigin.id,
            lat: this.depotOrigin.address.lat,
            lon: this.depotOrigin.address.lon,
          },
        ];
        if (this.depotDestination) {
          destinations.push({
            name: this.depotDestination.id,
            lat: this.depotDestination.address.lat,
            lon: this.depotDestination.address.lon,
          });
        }
        this.distanceMatrixManual.destinations.push(...destinations);
      }
    },
    async addParameters() {
      this.optimizationBody.parameters['trafficFactor'] = this.trafficFactor.factor;
      this.optimizationBody.parameters['useAllFleet'] = this.useAllFleet;
      this.optimizationBody.parameters['useGeofences'] = this.useGeoFence;
    },
    async addOperations(mode) {
      let i = 0;
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `Comenzando a construir las operaciones ->`,
      });

      for (const operation of this.operations) {
        try {
          if (this.planificationId) {
            this.updateDistanceMatrix(operation);
          }

          this.sanitizeDocuments(operation);
          const operationOptimization = this.buildOperationOptimization(operation, i, mode);

          this.collectTags(operation);

          this.optimizationBody.operations.push(operationOptimization);
          this.optimizationBody.tags = [...new Set(this.optimizationBody.tags)];
          i += 1;
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBUilder',
            message: `La operación tuvo un error al iterar ${e.message}`,
            data: operation,
          });
          throw e;
        }
      }
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `Los tags usados para la optimización`,
        data: { tags: this.optimizationBody.tags },
      });
    },

    updateDistanceMatrix(operation) {
      const index = this.distanceMatrixManual.operations.findIndex((op) => op.uuid === operation.uuid);
      if (index !== -1) {
        this.distanceMatrixManual.operations[index] = operation;
      }
    },

    sanitizeDocuments(operation) {
      operation.documents = operation.documents || [];
      for (let document of operation.documents) {
        document.items = document.items || [];
        for (let item of document.items) {
          delete item.itemSelected;
        }
      }
    },

    buildOperationOptimization(operation, index, mode) {
      const operationOptimization = {
        uuid: operation.uuid,
        name: operation.name,
        resourceId: 0,
        idSpotTemporal: operation.idSpotTemporal,
        spotServiceTime: operation.spotServiceTime * 60,
        spot: operation.idSpotTemporal,
        depot: this.depotOrigin.id,
        volume: operation.volume || 0,
        weight: operation.weight || 0,
        money: operation.money || 0,
        type: operation.typeOperation?.type || operation.typeOperation,
        extraInfo: {
          idSolver: index,
          customerName: operation.contact?.toString() || null,
          customerPhone: operation.phone?.toString() || null,
          customerEmail: operation.email?.toString() || null,
          idSender: operation.sender?.id || null,
          documents: operation.documents || [],
          operationState: operation.operationState,
          geocodingResult: operation.geocodingResult,
          additionalInfo: operation.additionalInfo,
        },
      };

      // Si tienes un "mode" que requiere resource, se agrega aquí
      if (mode !== null && (mode === 'keepRoutes' || mode === 'keepRoutesOngoing')) {
        const resourceName = this.findResourceForOperation(operation.uuid);
        if (resourceName) {
          operationOptimization.resource = resourceName;
          if(operation.spotEndTime){
            operationOptimization.spotEndTime = operation.spotEndTime;
          }
        }
      }
      if (operation.tags) {
        operationOptimization.tags = this.isArrayOfObjects(operation.tags)
          ? operation.tags.map((tag) => tag.id.toString())
          : [operation.tags.id.toString()];
      }
      if (operation.startHour && operation.endHour) {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `las fechas para periodo horario`,
          data: {
            initHour: operation.startHour,
            endHour: operation.endHour,
          },
        });

        const startDateIso = `${this.form.executionDate} ${operation.startHour}:00`;
        const endDateIso = `${this.form.executionDate} ${operation.endHour}:00`;

        return {
          ...operationOptimization,
          spotTimeWindow: {
            startTime: new Date(startDateIso).getTime(),
            endTime: new Date(endDateIso).getTime(),
          },
        };
      }

      return operationOptimization;
    },
    findResourceForOperation(uuid) {
      for (const route of this.optimizationOutput.routes) {
        for (const resource of route.resources) {
          for (const operation of resource.operations) {
            if (operation.uuid === uuid) {
              const vehicleId = resource.extraInfo?.vehicle?.id;
              if (this.checkedVehicles.includes(vehicleId)) {
                return resource.name;
              }
            }
          }
        }
      }
      return null;
    },
    collectTags(operation) {
      if (!operation.tags) return;

      let tags = [];

      if (Array.isArray(operation.tags)) {
        if (this.isArrayOfObjects(operation.tags)) {
          tags = operation.tags.map((tag) => tag.id.toString());
        } else {
          tags = operation.tags.map((tag) => tag.toString());
        }
      } else {
        tags = [operation.tags.id.toString()];
      }

      this.optimizationBody.tags.push(...tags);
    },
    isArrayOfObjects(array) {
      return Array.isArray(array) && array.every((item) => typeof item === 'object' && item !== null);
    },
    selectOption(option, disabled) {
      if (!disabled && !this.isOptimizationBussy) {
        this.selectedButtonOption = option;
      }
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    cleanFilterText() {
      this.filterVehicleTemp = null;
      this.applyFilter();
    },
    async applyFilter() {
      this.selectedAllVehicles = false;
      this.isMainPageBussy = true;
      this.filterVehicle = this.filterVehicleTemp;
      await this.$nextTick(); // le das tiempo al DOM a reflejar el estado ocupado
      this.vehiclesFilter = this.vehicles.filter((veh) => {
        if (!this.filterVehicle) {
          return true; // Si filterVehicle es null o vacío, devolver todos los vehículos
        }
        const plateMatch = veh.plate.toLowerCase().includes(this.filterVehicle.toLowerCase().trim());
        const tagsMatch =
          Array.isArray(veh.tags) &&
          veh.tags.some((tag) => tag.name.toLowerCase().includes(this.filterVehicle.toLowerCase().trim()));

        const driverMatch =
          veh.driver && veh.driver.driverName.toLowerCase().includes(this.filterVehicle.toLowerCase().trim());

        // Devolver true si coincide con alguna de las condiciones
        return plateMatch || tagsMatch || driverMatch;
      });
      this.isMainPageBussy = false;
    },
    validateVehiclesInRoute() {
      if (!this.planIsOngoing) return true;

      const hasMissingDriver = this.optimizationResultParsed.some((route) => !route.driver);
      const hasMissingVehicle = this.optimizationResultParsed.some((route) => !route.vehicle);

      if (hasMissingDriver && hasMissingVehicle) {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.routeWODriversAndVehicles'),
          'error',
        );
        return false;
      }

      if (hasMissingDriver) {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.routeWODrivers'),
          'error',
        );
        return false;
      }

      if (hasMissingVehicle) {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.routeWOVehicles'),
          'error',
        );
        return false;
      }

      return true;
    },
    validateCheckVehicles() {
      if (this.checkedVehicles.length > 0) {
        return true;
      }
      showAlert(
        this.$t('common.modals.errorTitulo'),
        this.$t('planification.planificationBuilder.validaciones.checkVehicles'),
        'error',
      );
      return false;
    },
    validateDriversSelected() {
      let vehiclesSelected = this.vehicles.filter((vehicle) => this.checkedVehicles.includes(vehicle.id));
      //Verificar que cada vehículo seleccionado tenga un conductor
      let totalDrivers = 0;
      let listDriver = [];
      vehiclesSelected.forEach((vehicle) => {
        if (vehicle.driver) {
          totalDrivers = totalDrivers + 1;
          listDriver.push(vehicle.driver.id);
        }
      });
      console.log(vehiclesSelected);
      listDriver = [...new Set(listDriver)];
      if (totalDrivers == vehiclesSelected.length) {
        //verifica que la cantidad de conductores unicos sea igual a los vehículos seleccionados
        if (listDriver.length == vehiclesSelected.length) {
          return true;
        } else {
          showAlert(
            this.$t('common.modals.errorTitulo'),
            this.$t('planification.planificationBuilder.validaciones.differentDrivers'),
            'error',
          );
        }
      } else {
        showAlert(
          this.$t('common.modals.errorTitulo'),
          this.$t('planification.planificationBuilder.validaciones.notDrivers'),
          'error',
        );
      }
      return false;
      //
    },

    /**
     * Metodo que construye los depots de la planificación, y coloca las horas de inicio y termino, y nombre de la planificacion
     */
    makeBodyDepots() {
      let startDate = this.form.executionDate + ' ' + this.form.initHour;
      let endDate = this.form.executionDate + ' ' + this.form.endHour;

      const dateFrom = new Date(startDate);
      const secondsFrom = dateFrom.getTime();

      const dateUntil = new Date(endDate);
      const secondsUntil = dateUntil.getTime();
      let depotsData = [];
      let bodyDepotOrigin;
      let bodyDepotDestination;
      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `Por construir makeBodyDepots con ${startDate} y termino ${endDate}, su timestamp es ${secondsFrom} y ${secondsUntil}`,
      });
      try {
        if (this.depotOrigin !== null) {
          bodyDepotOrigin = {
            name: this.depotOrigin.id,
            lat: this.depotOrigin.address.lat,
            lon: this.depotOrigin.address.lon,
            timeWindow: {
              startTime: secondsFrom,
              endTime: secondsUntil,
            },
            extraInfo: {
              id: this.depotOrigin.id,
              address:
                this.depotOrigin.address.street +
                ',' +
                this.depotOrigin.address.city +
                ',' +
                this.depotOrigin.address.state +
                ',' +
                (this.depotOrigin.address.country !== null && this.depotOrigin.address.country !== undefined
                  ? this.depotOrigin.address.country.name
                  : ''),
              //zone: this.depotOrigin.zone,
              //type: this.depotOrigin.type,
              //description: this.depotOrigin.description,
            },
          };
          depotsData.push(bodyDepotOrigin);
        }
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `Fallo el proceso de añadir la bodega de origen ${e.message}`,
          data: this.depotOrigin,
        });
        throw e;
      }
      try {
        if (this.depotDestination !== null) {
          bodyDepotDestination = {
            name: this.depotDestination.id,
            lat: this.depotDestination.address.lat,
            lon: this.depotDestination.address.lon,
            timeWindow: {
              startTime: secondsFrom,
              endTime: secondsUntil,
            },
            extraInfo: {
              id: this.depotDestination.id,
              address:
                this.depotDestination.address.street +
                ',' +
                this.depotDestination.address.city +
                ',' +
                this.depotDestination.address.state +
                ',' +
                (this.depotDestination.address.country !== null && this.depotDestination.address.country !== undefined
                  ? this.depotDestination.address.country.name
                  : ''),
              //zone: this.depotDestination.zone,
              //type: this.depotDestination.type,
              //description: this.depotDestination.description,
            },
          };
          depotsData.push(bodyDepotDestination);
        }
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `Fallo el proceso de añadir la bodega de destino ${e.message}`,
          data: this.depotDestination,
        });
        throw e;
      }
      this.optimizationBody.name = this.form.planificationName;
      this.optimizationBody.startDate = secondsFrom;
      this.optimizationBody.endDate = secondsUntil;
      this.optimizationBody.depots = depotsData;
      this.optimizationBody.timezone = this.$store.getters.timeZone;
    },
    makeBodyGeofences() {
      if (this.useGeoFence && this.geoFence.length > 0) {
        this.logService.sendInfo({
          component: 'planificationBUilder',
          message: `Por construir makeBodyGeofences usar geocercas: ${this.useGeoFence}, total de geocercas a enviar ${this.geoFence.length} `,
        });
        let geofencesOp = [];
        this.geoFence.forEach((g) => {
          let gPoints = g.zone.map((z) => {
            return [z.lon, z.lat];
          });
          gPoints.push(gPoints[0]);
          geofencesOp.push({
            name: g.id,
            points: gPoints,
          });
        });
        this.optimizationBody.geofences = geofencesOp;
      }
    },
    async makeBodyVehicles() {
      let resources = [];
      let listOfTypes = [];
      //Obtengo el listado de vehículos seleccionados (checkedVehicles solo contiene patentes)
      let completeInfoVehicle = this.vehicles.filter((vehicle) => this.checkedVehicles.includes(vehicle.id));

      this.logService.sendInfo({
        component: 'planificationBUilder',
        message: `Por construir makeBodyVehicles`,
        data: this.checkedVehicles,
      });
      for (const vehicle of completeInfoVehicle) {
        try {
          if (vehicle.vehicleTypeExtra && !listOfTypes.some((type) => type.id === vehicle.vehicleTypeExtra.id)) {
            //Input para el optimizador sobre los tipos de vehículos y sus caracteristicas
            listOfTypes.push(this.buildResourceType(vehicle.vehicleTypeExtra));
          }
          const body = this.buildVehicleBody(vehicle);
          resources.push(body);
        } catch (e) {
          this.logService.sendError({
            component: 'planificationBUilder',
            message: `Fallo el proceso de construir el body de vehículos ${e.message}`,
            data: vehicle,
          });
          throw e;
        }
      }
      this.optimizationBody.resourceTypes = listOfTypes;
      this.optimizationBody.resources = resources;
    },

    buildResourceType(vehicleTypeExtra) {
      return {
        id: vehicleTypeExtra.id,
        name: vehicleTypeExtra.name,
        maxWeight: vehicleTypeExtra.maxWeigth > 0 ? vehicleTypeExtra.maxWeigth : 0,
        maxMoney: vehicleTypeExtra.maxMoney > 0 ? vehicleTypeExtra.maxMoney : 0,
        maxVolume: vehicleTypeExtra.maxVolume > 0 ? vehicleTypeExtra.maxVolume : 0,
        maxKms: vehicleTypeExtra.maxKms > 0 ? vehicleTypeExtra.maxKms : 0,
        maxVisits: vehicleTypeExtra.maxVisits > 0 ? vehicleTypeExtra.maxVisits : 0,
        maxTime: vehicleTypeExtra.maxTime > 0 ? vehicleTypeExtra.maxTime : 0,
        maxTimeDriving: vehicleTypeExtra.maxTimeDriving > 0 ? vehicleTypeExtra.maxTimeDriving : 0,
        maxContinuosTimeDriving:
          vehicleTypeExtra.maxContinuousTimeDriving > 0 ? vehicleTypeExtra.maxContinuousTimeDriving : 0,
      };
    },

    buildVehicleBody(vehicle) {
      const body = {
        name: vehicle.plate,
        type: vehicle.vehicleTypeExtra?.name ?? null,
        depotStart: this.depotOrigin?.id ?? null,
        extraInfo: {
          driver: {
            id: vehicle.driver?.id ?? null,
            driverName: vehicle.driver?.driverName ?? null,
          },
          vehicle: {
            id: vehicle.id,
            plate: vehicle.plate,
            idVehicleOperaciones: vehicle.id_vehicle_operaciones ?? null,
          },
        },
        ...(this.depotDestination ? { depotEnd: this.depotDestination.id } : {}),
        ...(this.useGeoFence
          ? { geofences: vehicle.selectedGeoFence ? [vehicle.selectedGeoFence.id.toString()] : [] }
          : {}),
      };

      if (vehicle.tags?.length) {
        console.log('Los tags de este vehículo ', vehicle.tags);
        const listIdTags = vehicle.tags.map((tag) => tag.id.toString());
        body.tags = listIdTags;
        this.optimizationBody.tags = [...this.optimizationBody.tags, ...listIdTags];
        console.log('Los tags totales  ', this.optimizationBody.tags);
      }

      return body;
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    getImageSrc(value) {
      // Aquí haces un mapeo simple
      const images = {
        keepRoutes: require('@/assets/buttonOptimize/keepRoutes.svg'),
        keepRoutesOngoing: require('@/assets/buttonOptimize/keepRoutes.svg'),
        manual: require('@/assets/buttonOptimize/manual.svg'),
        reoptimize: require('@/assets/buttonOptimize/reoptimize.svg'),
      };

      return images[value] || '';
    },
    vehicleOptions(route) {
      const listVehicle = this.vehicles;

      const routeTags = route.tags ? Array.from(route.tags) : [];
      const currentVehicleId = route.vehicle?.id;
      const usedVehicleIds = this.optimizationResultParsed
        .filter((r) => r.id !== route.id && r.vehicle?.id) // ignorar la ruta actual y vehículos null
        .map((r) => r.vehicle.id);

      const filteredVehicles = listVehicle
        .filter((vehicle) => {
          const vehicleTags = vehicle.tags ? vehicle.tags.map((tag) => tag.id) : [];

          // Primero validamos los tags
          if (routeTags.length > 0) {
            // La ruta tiene tags, el vehículo debe tener todos esos tags
            const hasAllTags = routeTags.every((tagId) => vehicleTags.includes(parseInt(tagId)));
            if (!hasAllTags) {
              return false;
            }
          } else {
            // La ruta NO tiene tags, el vehículo no debe tener ningún tag
            if (vehicleTags.length > 0) {
              return false;
            }
          }

          // Ahora validamos las capacidades
          const { maxWeigth, maxVolume, maxMoney, maxTime, maxKms } = vehicle.vehicleTypeExtra || {};

          if (!this.isCapacityOk(maxWeigth, route.totalWeight)) return false;
          if (!this.isCapacityOk(maxVolume, route.totalVolume)) return false;
          if (!this.isCapacityOk(maxMoney, route.totalMoney)) return false;
          if (!this.isCapacityOk(maxTime, route.totalTime)) return false;
          if (!this.isCapacityOk(maxKms, route.totalDistance)) return false;

          // Si pasa ambas validaciones, lo dejamos
          return true;
        })
        .map((vehicle) => {
          // Si el vehículo está asignado a otra ruta, pero no a esta, se desactiva
          const isUsedInAnotherRoute = usedVehicleIds.includes(vehicle.id);
          const $isDisabled = isUsedInAnotherRoute && vehicle.id !== currentVehicleId;

          return {
            ...vehicle,
            $isDisabled,
          };
        });

      return filteredVehicles;
    },

    // Función auxiliar para validar la capacidad
    isCapacityOk(vehicleValue, routeValue) {
      // Si el límite del vehículo es 0, no tiene restricción
      if (vehicleValue === 0) return true;
      // Si no, el vehículo debe ser igual o mayor a la necesidad de la ruta
      return vehicleValue >= routeValue;
    },
    /**
     * Mapea el listado de conductores, deshabilita a los conductores que esten siendo utilizados por otros vehículos,
     * pero no deshabilita el conductor que esta usando el vehículo de la fila seleccionada
     * @returns
     */
    driverOptions(vehicle) {
      //Si por algun motivo no llega un vehículo entonces pongo id 0 para que no falle la validación
      const selectedIdVehicle = vehicle?.id || 0;
      const checkedVehicleIds = new Set(this.checkedVehicles);
      return this.drivers.map((driver) => {
        const isDriverTaken = this.vehicles.some(
          (v) => v.driver && v.driver.id === driver.id && v.id !== selectedIdVehicle && checkedVehicleIds.has(v.id),
        );
        return {
          ...driver,
          $isDisabled: isDriverTaken,
        };
      });
    },
    renderedDrivers(vehicle) {
      return [
        {
          id: -1,
          driverName: this.$t('vehicle.modals.otros.newDriver'),
          $isDisabled: false,
        },
        ...this.driverOptions(vehicle),
      ];
    },
  },
  computed: {
    jsonData() {
      return this.$store.getters.jsonDataPlanification || {};
    },
    itemsVehicles() {
      const vehicles = this.vehiclesFilter.map((v) => {
        v.available = !this.bussyVehicles.includes(v.id);
        v.checked = this.checkedVehicles.includes(v.id);
        return {
          ...v,
          driver: v.driver ? v.driver : null,
          available: v.available,
          checkedVeh: v.checked,
          tags: v.tags,
          capacity: v.capcity,
          _rowVariant: v.checked && this.planIsOngoing ? 'secondary' : '',
        };
      });
      return vehicles;
    },
    buttonsMenuOptimization() {
      const buttons = this.buttonOptionsNotOngoing
        .filter((button) => button.ongoing === this.planIsOngoing)
        .map((button) => ({ ...button }));
      console.log('Botones ', buttons);
      return buttons;
    },
    routeFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      const left = {
        class: 'text-left',
        tdClass: 'small',
      };
      let fields = [
        {
          key: 'name',
          label: this.$t('planification.planificationBuilder.table.route'),
          ...left,
        },
        {
          key: 'totalOperations',
          label: this.$t('planification.planificationBuilder.table.operations'),
          ...common,
        },
        {
          key: 'vehicle',
          label: this.$t('planification.planificationBuilder.table.vehicle'),
          ...common,
        },
        {
          key: 'driver',
          label: this.$t('planification.planificationBuilder.table.driver'),
          ...common,
        },
      ];
      return fields;
    },
    vehicleFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      const left = {
        class: 'text-left',
        tdClass: 'small',
      };
      let fields = [
        {
          key: 'select',
          label: '',
          ...common,
        },
        {
          key: 'plate',
          label: this.$t('planification.planificationBuilder.table.plate'),
          ...left,
        },
        {
          key: 'tags',
          label: this.$t('planification.planificationBuilder.table.tags'),
          ...left,
        },
        {
          key: 'capacity',
          label: this.$t('planification.planificationBuilder.table.capacity'),
          ...left,
        },
        {
          key: 'driver',
          label: this.$t('planification.planificationBuilder.table.driver'),
          ...common,
        },
      ];
      if (this.useGeoFence) {
        fields = [
          ...fields,
          {
            key: 'geoFence',
            label: this.$t('planification.planificationBuilder.table.geoFence'),
            ...common,
          },
        ];
      }
      return fields;
    },
  },
};
